import * as React from 'react';

import { GuestGuard } from 'components/auth/guest-guard';
import { Layout } from 'components/auth/layout';
import { SignInForm } from 'components/auth/sign-in-form';
import {SignInWithEmailLinkForm} from "../../components/auth/sign-in-with-email-link-form";

export default function SignIn(): React.JSX.Element {
  return (
    <Layout>
      <GuestGuard>
        <SignInWithEmailLinkForm />
      </GuestGuard>
    </Layout>
  );
}
